// extracted by mini-css-extract-plugin
export var youtube = "Video-module--youtube--ffc3b";